import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentJpkEEShouldBeSelectedInWstoskTransactionError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.wsto-document.document-jpk-ee-should-be-selected-in-wstosk-transaction-error');
    }
}
